import React, { useState, useEffect } from 'react';
import VIPSection from './components/VIPSection';
import LandingHeader from './components/landing/LandingHeader';
import HeroSection from './components/landing/HeroSection';
import ProblemSection from './components/landing/ProblemSection';
import SolutionSection from './components/landing/SolutionSection';
import ValidationProofSection from './components/landing/ValidationProofSection';
import BetaBenefitsSection from './components/landing/BetaBenefitsSection';
import EarnSection from './components/landing/EarnSection';
import WaitlistForm from './components/landing/WaitlistForm';
import FAQSection from './components/landing/FAQSection';
import HelpUsBuildPanel from './components/landing/HelpUsBuildPanel';
import LandingFooter from './components/landing/LandingFooter';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Landing page shell — fetches live stats + beta-gate flag, then composes
 * the 10 section components. State that only one section needs now lives
 * inside that section (form state in WaitlistForm, openFaq in FAQSection).
 */
export default function LandingPage() {
  const [stats, setStats] = useState(null);
  const [showBetaMessage, setShowBetaMessage] = useState(false);

  // Live validation stats (cached server-side for 60s).
  useEffect(() => {
    fetch(`${API}/api/public/stats`)
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => { if (data) setStats(data); })
      .catch(() => {});
  }, []);

  // Beta-access redirect flag from the /login gate.
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('beta_access_required') === 'true') {
      setShowBetaMessage(true);
      setTimeout(() => {
        document.getElementById('waitlist-form')?.scrollIntoView({ behavior: 'smooth' });
      }, 500);
    }
  }, []);

  return (
    <div className="min-h-screen bg-[#050505]" style={{ fontFamily: "'DM Sans', sans-serif" }}>
      <LandingHeader />
      <HeroSection stats={stats} />
      <ProblemSection />
      <SolutionSection />
      <ValidationProofSection stats={stats} />
      <BetaBenefitsSection />
      <EarnSection />
      <WaitlistForm showBetaMessage={showBetaMessage} />
      <VIPSection />
      <FAQSection />
      <HelpUsBuildPanel />
      <LandingFooter />
    </div>
  );
}
